import * as React from "react";
import { firebaseDB, auth } from "../firebase";
import { database } from "firebase";
import { User } from "../types";

interface UsersDataContext {
	user?: User;
	isAuthed: boolean;
}

const defaultValue: UsersDataContext = {
	isAuthed: false
};

const { Provider, Consumer } = React.createContext<UsersDataContext>(
	defaultValue
);

interface IProps {}

interface IState {
	isAuthed: boolean;
	user?: User;
	ref?: any;
}

class UserDataProvider extends React.Component<IProps, IState> {
	state = {
		isAuthed: false,
		user: {
			name: "",

			answers: {}
		},
		ref: null
	};

	componentDidMount() {
		auth.onAuthStateChanged(user => {
            console.log(user) ;
            if (user) {
				this.registerListener();
			} else {
				this.removeListener();
			}
		});
	}

	registerListener = () => {
		const ref = firebaseDB.ref("users/" + auth.currentUser.uid);
		ref.on("value", snapshot => {
			this.setState({ user: snapshot.val(), isAuthed: true });
		});

		this.setState({ ref: ref });
	};

	removeListener = () => {
		this.state.ref.off("value");
		this.setState({ ref: null, isAuthed: null, user: null });
	};

	render() {
		return (
			<Provider
				value={{ isAuthed: this.state.isAuthed, user: this.state.user }}
			>
				{this.props.children}
			</Provider>
		);
	}
}

export { UserDataProvider };

export interface WithUserProps {
	user: UsersDataContext;
}

export const WithUser = Component => {
	return function WithLoggedInRedirect(props) {
		return (
			<Consumer>
				{userData => <Component user={userData} {...props} />}
			</Consumer>
		);
	};
};

export const AwaitWithUser = Component => {
	return function AwaitWithUser(props) {
		return (
			<Consumer>
				{userData =>
					userData.isAuthed ? (
						<Component user={userData} {...props} />
					) : null
				}
			</Consumer>
		);
	};
};



// WEBPACK FOOTER //
// ./src/helpers/UserDataProvider.tsx